import {
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import Card from 'components/card/Card';

interface FormWrapperProps {
  title: string;
  onClose: () => void;
  asPage?: boolean;
  footer: React.ReactNode;
  children: React.ReactNode;
  isLoading?: boolean;
}

export default function FormWrapper({
  title,
  onClose,
  asPage,
  footer,
  children,
  isLoading,
}: FormWrapperProps) {
  if (asPage) {
    return (
      <Box>
        <Card p={6}>
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            {title}
          </Text>
          <VStack spacing={5} alignItems="start">
            {children}
          </VStack>
          <HStack spacing={4} mt={6} justify="flex-end">
            {footer}
          </HStack>
        </Card>
      </Box>
    );
  }

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      closeOnOverlayClick={!isLoading}
      closeOnEsc={!isLoading}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton isDisabled={isLoading} />
        <ModalBody>
          <VStack spacing={5} alignItems="start">
            {children}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={4}>{footer}</HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
